import React, { Suspense } from "react";
import { lazyWithRetry } from "../utils/lazyWithRetry";
import { LazyFallback } from "../components/LazyFallback";

// Raw thunk for background prefetch (must not go through lazyWithRetry —
// a silent prefetch failure must never reload the page).
export const loadBoard = () => import("./Board");

const Board = lazyWithRetry(() =>
  loadBoard().then((m) => ({ default: m.Board })),
);

export const BoardLazy = (props: any) => (
  <Suspense fallback={<LazyFallback />}>
    <Board {...props} />
  </Suspense>
);
